import { createContext, type ReactElement, useState } from "react";

import { type CurrentUser } from "../api/types";

interface ContextState {
  user: CurrentUser;
  setUser: (user: CurrentUser) => void;
}

export const UserContext = createContext<ContextState | undefined>(undefined);

interface Props {
  user: CurrentUser;
  children: ReactElement;
}

export const UserProvider = ({ user: initUser, children }: Props) => {
  const [user, setUser] = useState<CurrentUser>(initUser);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
